import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { DockListFacade } from './dock-list.facade';

@Injectable({
  providedIn: 'root',
})
export class DockListGuard {
  constructor(private dockListFacade: DockListFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { hubId },
    } = route;
    return loadStoreState(this.dockListFacade, hubId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dockListFacade);
  }
}
